/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import type {
  CreateSystemIssueAlertPayload,
  SystemIssueAlert,
  SystemIssueAlertsQueryResult,
  UpdateSystemIssueAlertPayload,
} from '@poweralpha/common';
import { useQuery } from '@tanstack/react-query';
import type { HTTPError } from 'ky';
import { api } from '../api';
import type { QueryOptions } from '../react-components/queries';

export const systemIssueAlertsQueryKey = ['system-issue-alerts'] as const;

export const getSystemIssueAlertsQueryKey = (active = false) => [
  ...systemIssueAlertsQueryKey,
  { active },
];

export const useSystemIssueAlertsQuery = <TData = SystemIssueAlertsQueryResult>(
  opts?: QueryOptions<SystemIssueAlertsQueryResult, HTTPError, TData> & { active?: boolean },
) => {
  const { active = false, ...queryOptions } = opts ?? {};

  return useQuery<SystemIssueAlertsQueryResult, HTTPError, TData>({
    queryKey: getSystemIssueAlertsQueryKey(active),
    queryFn: () =>
      api.get('system-issues', { searchParams: active ? { active: 'true' } : undefined }).json(),
    ...queryOptions,
  });
};

export const createSystemIssueAlert = async (
  payload: CreateSystemIssueAlertPayload,
): Promise<SystemIssueAlert> => api.post('system-issues', { json: payload }).json();

export const updateSystemIssueAlert = async (
  id: string,
  payload: UpdateSystemIssueAlertPayload,
): Promise<SystemIssueAlert> => api.post(`system-issues/${id}`, { json: payload }).json();

export const resolveSystemIssueAlert = async (id: string): Promise<SystemIssueAlert> =>
  api.post(`system-issues/${id}/resolve`).json();
